import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { DeliveryVoucher } from 'contracts/DeliveryVouchers';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_DELIVERY_VOUCHER_',
  }
);

export interface FetchDeliveryVoucherState {
  data: DeliveryVoucher | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchDeliveryVoucherRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: DeliveryVoucher;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchDeliveryVoucherState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchDeliveryVoucherState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchDeliveryVoucherState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchDeliveryVoucherState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchDeliveryVoucherState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchDeliveryVoucher = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchDeliveryVoucherTypes = Types;
export const FetchDeliveryVoucherActions = Creators;
